import { useEffect, useMemo } from "react";

const COLORS = ["#D01012", "#F7C500", "#0067BF", "#00923F", "#F57D20", "#F5F0E6"];

export default function LegoConfetti({ onDone }) {
  const bricks = useMemo(
    () =>
      Array.from({ length: 70 }, (_, i) => {
        const scale = 0.7 + Math.random() * 0.9;
        return {
          id: i,
          dx: (Math.random() - 0.5) * Math.min(window.innerWidth * 0.9, 1000),
          up: 120 + Math.random() * 320,
          fall: window.innerHeight * (0.55 + Math.random() * 0.4),
          rot: (Math.random() - 0.5) * 900,
          delay: Math.random() * 0.25,
          color: COLORS[i % COLORS.length],
          w: 18 * scale,
          h: 9 * scale,
        };
      }),
    []
  );

  useEffect(() => {
    const t = setTimeout(() => onDone && onDone(), 3200);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div className="fixed inset-0 z-[100] pointer-events-none overflow-hidden" data-testid="lego-confetti" aria-hidden="true">
      {bricks.map((b) => (
        <span
          key={b.id}
          className="mc-confetti-brick"
          style={{
            width: b.w,
            height: b.h,
            backgroundColor: b.color,
            color: b.color,
            "--dx": `${b.dx}px`,
            "--up": `${b.up}px`,
            "--fall": `${b.fall}px`,
            "--rot": `${b.rot}deg`,
            animationDelay: `${b.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
